var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "picture",
    { ref: "picture" },
    [
      _setup.file
        ? _c("source", {
            attrs: { sizes: _vm.sizes, srcset: _setup.getSrcset() },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_setup.types, function (format, mimeType) {
        return _setup.file
          ? _c("source", {
              key: format,
              attrs: {
                sizes: _vm.sizes,
                srcset: _setup.getSrcset(format),
                type: mimeType,
              },
            })
          : _vm._e()
      }),
      _vm._v(" "),
      _setup.show
        ? _c("img", {
            attrs: { alt: _vm.alt, src: _setup.src },
            on: {
              click: function ($event) {
                $event.preventDefault()
                $event.stopPropagation()
                return _vm.onClick.apply(null, arguments)
              },
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }